
import { Vue, Component, Prop } from 'vue-property-decorator'
import BaseIcon from 'vuecomponents/base_icon.vue'

@Component({
  components: { BaseIcon },
})
export default class extends Vue {
  @Prop(String) private message!: string
  @Prop(String) private actionText!: string
  @Prop(String) private actionUrl!: string
  @Prop({ type: Boolean, default: false }) private hasCloseButton!: boolean

  get hasLink(): boolean {
    return !!(this.actionText && this.actionUrl)
  }

  get hasAction(): boolean {
    return !!this.actionText && !this.actionUrl
  }
}
